"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var recharts_1 = require("recharts");
var core_1 = require("@material-ui/core");
var icons_1 = require("../../../common/icons");
var image_1 = require("../../../common/image");
var sleepService_1 = require("../../../app/services/sleepService");
var translate_1 = __importDefault(require("../../../app/localization/translate"));
var components_1 = require("../../../common/components");
var breadcrumbUtil_1 = require("../../../common/breadcrumbUtil");
var store_1 = require("../../../app/store");
var dateUtils_1 = require("../../../youwell-common/dateUtils");
var arrayUtils_1 = require("../../../youwell-common/arrayUtils");
var browserUtils_1 = require("../../../youwell-common/browserUtils");
var RegisterSleepMenu_1 = __importDefault(require("./components/RegisterSleepMenu"));
var InfoBox_1 = __importDefault(require("./components/InfoBox"));
var utils_1 = require("./utils");
var WeekAverageDetails_1 = __importDefault(require("./components/WeekAverageDetails"));
var EditBedtimePlan_1 = __importDefault(require("./components/EditBedtimePlan"));
var constants_1 = require("../../../youwell-common/constants");
var constants_2 = require("./constants");
var SleepDetailsTable_1 = __importDefault(require("./components/SleepDetailsTable"));
var WeekSelector_1 = __importDefault(require("./components/WeekSelector"));
var useStyles = (0, core_1.makeStyles)(function (theme) {
    var _a, _b, _c;
    return (0, core_1.createStyles)({
        top: (_a = {
                marginBottom: theme.spacing(4)
            },
            _a[theme.breakpoints.down('xs')] = {
                marginBottom: theme.spacing(4),
            },
            _a),
        mainHeading: {
            textTransform: 'uppercase',
            marginBottom: theme.spacing(2),
        },
        content: {
            marginBottom: theme.spacing(8),
            '&:last-child': {
                marginBottom: theme.spacing(12),
            },
        },
        infoBoxes: (_b = {
                display: 'flex',
                margin: theme.spacing(4, 0, 8)
            },
            _b[theme.breakpoints.down('xs')] = {
                flexWrap: 'wrap',
            },
            _b),
        chartContent: (_c = {
                boxShadow: theme.shadows[2],
                background: theme.palette.common.white,
                paddingTop: theme.spacing(2)
            },
            _c[theme.breakpoints.down('xs')] = {
                overflowX: 'auto',
                overflowY: 'hidden',
                width: '100%',
            },
            _c),
        chartScrollContainer: {},
        chartTitle: {
            margin: theme.spacing(2),
        },
        chartDetails: {
            marginTop: theme.spacing(2),
        },
        weekSelection: {
            margin: theme.spacing(2, 0),
            display: 'flex',
            justifyContent: 'center',
        },
        infoLine: {
            display: 'flex',
            alignItems: 'center',
        },
        infoIcon: {
            width: 40,
            height: 40,
            marginRight: theme.spacing(2),
            color: theme.palette.secondary.main,
        },
        bedPlanLine: {
            display: 'flex',
            alignItems: 'center',
            marginBottom: theme.spacing(2),
        },
        bedPlanIcon: {
            width: 30,
            height: 30,
            marginRight: theme.spacing(2),
        },
        ratingDescription: {
            marginTop: theme.spacing(4),
        },
        noRegistrations: {
            background: theme.youwell.colors.secondaryBackground,
            padding: theme.spacing(2),
        },
        customTooltip: {
            backgroundColor: theme.youwell.colors.secondaryBackground,
            padding: theme.spacing(2),
            borderRadius: theme.youwell.shapes.borderRadius,
        },
    });
}, { name: 'SleepDiary' });
var SleepDiary = function () {
    var _a;
    var classes = useStyles();
    var dispatch = (0, store_1.useYouwellDispatch)();
    var translate = (0, translate_1.default)();
    var clientConfig = (0, store_1.useYouwellSelector)(function (state) { return state.auth.clientConfig; });
    var sleepEntries = (0, store_1.useYouwellSelector)(function (state) { return (0, arrayUtils_1.sortByDateAscending)(state.sleepDataStore.entries, 'date') || []; });
    var sleepEntriesLoadedFrom = (0, store_1.useYouwellSelector)(function (state) { return state.sleepDataStore.sleepEntriesLoadedFrom; });
    var selectedWeek = (0, store_1.useYouwellSelector)(function (state) { return state.sleepDataStore.selectedWeek; });
    var userData = (0, store_1.useYouwellSelector)(function (state) { var _a; return (_a = state.auth.profileData) === null || _a === void 0 ? void 0 : _a.extendedProperties; });
    var theme = (0, core_1.useTheme)();
    var isMobile = (0, core_1.useMediaQuery)(theme.breakpoints.down('xs'));
    var sleepLookup = React.useMemo(function () { return (0, utils_1.getSleepLookup)(sleepEntries); }, [sleepEntries]);
    var selectedWeekEntries = (0, utils_1.getRegistrationsForWeek)(sleepLookup, selectedWeek);
    var weekAverage = React.useMemo(function () { return (0, utils_1.getWeekAverage)(selectedWeekEntries); }, [selectedWeekEntries]);
    var hasRegistrationsForWeek = weekAverage.count > 0;
    var onWeekSelectionChange = function (week) {
        var localDate = (0, dateUtils_1.getLocalDate)(sleepEntriesLoadedFrom);
        if (sleepEntriesLoadedFrom && localDate && week.start < localDate) {
            localDate.setMonth(localDate.getMonth() - 1);
            (0, sleepService_1.fetchEntriesData)(dispatch, { startDate: localDate, endDate: sleepEntriesLoadedFrom });
        }
    };
    var _b = (0, browserUtils_1.useElementSize)(), contentRef = _b.elementRef, contentSize = _b.elementSize;
    var chartWidth = isMobile ? selectedWeekEntries.length * 80 : contentSize.width;
    var bedtimePlan = {
        bedTime: (userData === null || userData === void 0 ? void 0 : userData[constants_1.userDataProperties.bedtimePlan.bedTime]) || '',
        wakeTime: (userData === null || userData === void 0 ? void 0 : userData[constants_1.userDataProperties.bedtimePlan.wakeTime]) || '',
    };
    var hasBedtimePlan = Boolean(bedtimePlan.bedTime && bedtimePlan.wakeTime);
    var HistoryGraphTooltip = function (_a) {
        var _b, _c, _d, _e, _f, _g, _h, _j, _k;
        var active = _a.active, payload = _a.payload;
        if (active && payload && payload.length) {
            return (React.createElement("div", { className: classes.customTooltip },
                React.createElement(core_1.Typography, { variant: "subtitle2" }, (0, dateUtils_1.shortDate)((_c = (_b = payload[0]) === null || _b === void 0 ? void 0 : _b.payload) === null || _c === void 0 ? void 0 : _c.x, translate, false, false, true)),
                React.createElement(core_1.Typography, { variant: "body2", color: "primary" }, "".concat(translate('sleepDiary.totalSleep'), ": ").concat((0, dateUtils_1.hourCount)((_d = payload[0].payload) === null || _d === void 0 ? void 0 : _d.totalSleepMinutes, translate))),
                React.createElement(core_1.Typography, { variant: "body2", color: "primary" }, "".concat(translate('sleepDiary.sleepOnset'), ": ").concat((0, dateUtils_1.hourCount)((0, dateUtils_1.getNumberOfMinutes)((_f = (_e = payload[0]) === null || _e === void 0 ? void 0 : _e.payload) === null || _f === void 0 ? void 0 : _f.sleepTime, (_h = (_g = payload[0]) === null || _g === void 0 ? void 0 : _g.payload) === null || _h === void 0 ? void 0 : _h.sleepAtemptTime), translate))),
                React.createElement(core_1.Typography, { variant: "body2", color: "primary" }, "".concat(translate('sleepDiary.sleepEfficiency'), ": ").concat((_k = (_j = payload[0]) === null || _j === void 0 ? void 0 : _j.payload) === null || _k === void 0 ? void 0 : _k.y, "%"))));
        }
        return null;
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(components_1.PageLayout, { breadcrumb: (0, breadcrumbUtil_1.getBreadCrumb)(translate('sleepDiary.header'), translate, clientConfig) },
            React.createElement("div", { className: classes.top },
                React.createElement(core_1.Typography, { variant: "h4", className: classes.mainHeading }, translate('sleepDiary.header')),
                React.createElement(RegisterSleepMenu_1.default, { isModal: true, numberOfNightCards: 4 })),
            React.createElement("div", { className: classes.weekSelection, ref: contentRef },
                React.createElement(WeekSelector_1.default, { onChange: onWeekSelectionChange })),
            React.createElement("div", { className: classes.infoBoxes },
                React.createElement(InfoBox_1.default, { heading: translate('sleepDiary.sleepEfficiency'), subHeading: translate('sleepDiary.average'), Icon: icons_1.AnalyticsIcon, ActionPopup: hasRegistrationsForWeek ? WeekAverageDetails_1.default : null, ActionPopupProps: { weekAverage: weekAverage }, actionText: translate('sleepDiary.moreInformation'), actionPopupHeading: translate('sleepDiary.weekAverage') },
                    React.createElement("div", { className: classes.infoLine }, hasRegistrationsForWeek ? (React.createElement(React.Fragment, null,
                        React.createElement(icons_1.DotIcon, { className: classes.infoIcon }),
                        React.createElement(core_1.Typography, { variant: "h6" }, "".concat(Math.round(weekAverage.sleepQuality / weekAverage.count), " %")))) : (React.createElement(core_1.Typography, { variant: "caption" }, translate('sleepDiary.noEntriesForThisWeek'))))),
                React.createElement(InfoBox_1.default, { heading: translate('sleepDiary.qualityOfSleep'), subHeading: translate('sleepDiary.average'), Icon: icons_1.AnalyticsIcon },
                    React.createElement("div", { className: classes.infoLine }, hasRegistrationsForWeek ? (React.createElement("div", null,
                        React.createElement(core_1.Typography, { variant: "h6", align: "center" }, translate(((_a = constants_2.sleepRatings.find(function (d) { return Math.round(weekAverage.sleepRating / weekAverage.count) === d.id; })) === null || _a === void 0 ? void 0 : _a.label) || '', undefined, { onMissingTranslation: function () { return ''; } })),
                        React.createElement(core_1.Typography, { variant: "body1", align: "center" }, "".concat((weekAverage.sleepRating / weekAverage.count).toFixed(1))),
                        React.createElement(core_1.Typography, { variant: "caption", display: "block", className: classes.ratingDescription }, translate('sleepDiary.sleepRatingDescription')))) : (React.createElement(core_1.Typography, { variant: "caption" }, translate('sleepDiary.noEntriesForThisWeek'))))),
                React.createElement(InfoBox_1.default, { heading: translate('sleepDiary.bedtimePlan'), Icon: icons_1.AlarmIcon, ActionPopup: EditBedtimePlan_1.default, ActionPopupProps: { bedtimePlan: bedtimePlan }, actionText: translate('sleepDiary.editSleepPlan'), actionPopupHeading: translate('sleepDiary.bedtimePlan') }, hasBedtimePlan ? (React.createElement(React.Fragment, null,
                    React.createElement("div", { className: classes.bedPlanLine },
                        React.createElement(image_1.MoonIcon, { className: classes.bedPlanIcon }),
                        React.createElement(core_1.Typography, null, bedtimePlan.bedTime)),
                    React.createElement("div", { className: classes.bedPlanLine },
                        React.createElement(icons_1.SunIcon, { className: classes.bedPlanIcon }),
                        React.createElement(core_1.Typography, null, bedtimePlan.wakeTime)))) : (React.createElement(core_1.Typography, { variant: "caption" }, translate('sleepDiary.noSleepPlanCreated'))))),
            React.createElement("div", { className: (0, classnames_1.default)(classes.content, classes.chartContent) },
                React.createElement(core_1.Typography, { variant: "h5", className: classes.chartTitle, gutterBottom: true }, translate('sleepDiary.history')),
                React.createElement("div", { className: classes.chartScrollContainer, style: { width: chartWidth } },
                    hasRegistrationsForWeek ? (React.createElement(recharts_1.LineChart, { width: chartWidth, height: 300, data: selectedWeekEntries.map(function (d) {
                            var _a, _b, _c, _d;
                            return ({
                                x: d.isoDateString, y: (_a = d.entry) === null || _a === void 0 ? void 0 : _a.sleepQuality, sleepAtemptTime: (_b = d.entry) === null || _b === void 0 ? void 0 : _b.sleepAtemptTime, sleepTime: (_c = d.entry) === null || _c === void 0 ? void 0 : _c.sleepTime, totalSleepMinutes: (_d = d.entry) === null || _d === void 0 ? void 0 : _d.totalSleepMinutes,
                            });
                        }), margin: { top: 0, right: 16, bottom: 0, left: 160 } },
                        React.createElement(recharts_1.YAxis, { domain: [50, 100], ticks: [50, 60, 70, 80, 90, 100], tickFormatter: function (t) { return "".concat(t, " %"); } }),
                        React.createElement(recharts_1.Line, { dataKey: "y", strokeWidth: 4, stroke: theme.palette.secondary.main, dot: { stroke: theme.palette.primary.main, fill: theme.palette.primary.main, r: 8 } }),
                        React.createElement(recharts_1.CartesianGrid, { vertical: false }),
                        React.createElement(recharts_1.Tooltip, { content: React.createElement(HistoryGraphTooltip, null) }))) : (React.createElement(core_1.Typography, { variant: "body2", align: "center", className: classes.noRegistrations }, "".concat(translate('sleepDiary.noEntriesForThisWeek'), ". ").concat(translate('sleepDiary.clickDateToRegister')))),
                    React.createElement(SleepDetailsTable_1.default, { data: selectedWeekEntries, hasRegistrations: hasRegistrationsForWeek }))))));
};
exports.default = SleepDiary;
